export const genericThemeOptions = {
    stepIconColour: '#00AEEF',
    showOverviewIcon: false,
    showOverviewTime: false,
    showOverviewAttendees: false,
    showOverviewDate: false,
};
export default genericThemeOptions;
